"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelect = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const react_intl_1 = require("react-intl");
const iso_639_1_1 = __importDefault(require("iso-639-1"));
const useConfig_1 = require("@src/hooks/useConfig");
const getOtherLanguagesName_1 = require("@src/helpers/getOtherLanguagesName");
const { TreeNode } = antd_1.TreeSelect;
const LanguageSelect = ({ multiple = false, filterRemainingLanguages, value, defaultValue, onChange, }) => {
    const intl = (0, react_intl_1.useIntl)();
    const config = (0, useConfig_1.useConfig)();
    const translatedLanguages = config.languages;
    function filterUsedCodes(code) {
        if (!translatedLanguages.some(({ code: translatedCode }) => code === translatedCode)) {
            return code;
        }
    }
    // filter language codes which are already used in translatedLanguages
    const allNotTranslatedLanguageCodes = iso_639_1_1.default.getAllCodes().filter(filterUsedCodes);
    return ((0, jsx_runtime_1.jsxs)(antd_1.TreeSelect, { placeholder: intl.formatMessage({ id: 'profile.resume.language.select_language' }), showSearch: true, treeNodeFilterProp: "title", multiple: multiple, allowClear: true, value: value, defaultValue: defaultValue, onChange: onChange, children: [translatedLanguages
                .filter(language => (filterRemainingLanguages ? filterRemainingLanguages(language) : language))
                .map(language => ((0, jsx_runtime_1.jsx)(TreeNode, { value: language.code, title: language.value }, language.code))), (0, jsx_runtime_1.jsx)(TreeNode, { selectable: false, value: "all_languages", title: intl.formatMessage({
                    id: 'profile.resume.language.other',
                }), children: allNotTranslatedLanguageCodes.map((languageCode) => ((0, jsx_runtime_1.jsx)(TreeNode, { value: languageCode, title: (0, getOtherLanguagesName_1.getOtherLanguagesName)(languageCode) }, languageCode))) })] }));
};
exports.LanguageSelect = LanguageSelect;
